(function () {
  'use strict';

  if (window.__productSelloB2bAuthSyncInit) return;
  window.__productSelloB2bAuthSyncInit = true;

  var SECTION_ID = 'product-sello-b2b-pdp';
  var LOGIN_PATH = '/customer_authentication/login';
  var AUTH_TIMEOUT_MS = 10000;

  function getSectionUrl() {
    return window.location.pathname + '?section_id=' + SECTION_ID;
  }

  function getLoginUrl() {
    return LOGIN_PATH + '?return_to=' + encodeURIComponent(getSectionUrl());
  }

  function syncAuthViaIframe() {
    return new Promise(function (resolve) {
      var iframe = document.createElement('iframe');
      var settled = false;

      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.cssText =
        'position:absolute;width:0;height:0;border:0;visibility:hidden;pointer-events:none';

      function finish() {
        if (settled) return;
        settled = true;
        window.setTimeout(function () {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
          resolve();
        }, 300);
      }

      iframe.addEventListener('load', finish);
      iframe.addEventListener('error', finish);
      window.setTimeout(finish, AUTH_TIMEOUT_MS);

      iframe.src = getLoginUrl();
      document.body.appendChild(iframe);
    });
  }

  function fetchSelloRoot() {
    return fetch(getSectionUrl(), { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('[data-product-sello-b2b-root]');
      });
  }

  function refreshRoot(root) {
    return fetchSelloRoot().then(function (freshRoot) {
      if (!freshRoot) return;

      root.innerHTML = freshRoot.innerHTML;
      root.removeAttribute('data-auth-sync-pending');

      if (freshRoot.dataset.userType) {
        window.__USER_TYPE__ = freshRoot.dataset.userType;
      }
    });
  }

  function run() {
    var roots = document.querySelectorAll(
      '[data-product-sello-b2b-root][data-auth-sync-pending]'
    );

    if (!roots.length) return;

    syncAuthViaIframe().then(function () {
      Array.prototype.forEach.call(roots, function (root) {
        refreshRoot(root).catch(function () {});
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
